// Each vacancy is hidden automatically once `expires_at` has passed (checked on every page view).
export const JOBS = [
  {
    slug: "strategic-partnership-manager",
    title: "Strategic Partnership Manager",
    location: "Nationwide",
    type: "Full-time",
    closes: "30 November 2026",
    expires_at: "2026-11-30T23:59:59+01:00",
    sections: [
      { h: "Help every child start term on time", p: [
        "In many Nigerian homes, school fees are due at the start of term, but salaries come in monthly. Too many parents end up borrowing from expensive informal lenders, or their children miss the first weeks of school.",
        "AscentRemit fixes that. We pay the school the full fee upfront, and parents spread the cost over 3 to 9 months. They see the full price before they sign. We check every loan is affordable, allow early repayment with no penalty, and never involve a child in collections.",
        "We're growing across Nigeria, and we're looking for a Strategic Partnership Manager to build the network of schools, employers and partners that gets us there.",
      ] },
      { h: "What you'll do", li: [
        "Bring schools on board. Find private schools and school groups, show proprietors and bursars why a free partnership helps them, and sign them up.",
        "Partner with employers. Work with companies, government bodies and cooperatives so their staff can pay school fees monthly from their salary.",
        "Grow our agent network. Recruit, train and support agents, and make sure they follow our fair-lending and respectful-collections standards.",
        "Open funding and payment partnerships. Work with the founder on partnerships with banks, microfinance lenders, investors and payment providers.",
        "Launch every partnership well. Plan the onboarding, run back-to-school campaigns for parents, and give schools the materials they need to tell families about us.",
        "Keep partners growing. Review sign-ups, loan volume and repayments with each partner regularly, and fix problems quickly.",
        "Be our ear on the ground. Share what schools and parents tell you, so it shapes our product, pricing and risk decisions.",
        "Report on progress. Share monthly updates on your pipeline, partner performance and growth.",
        "Drive aggressive cross-selling. Use every partner school, employer and agent relationship to sell more AscentRemit products to the families they serve.",
        "Win parents over. Get parents paying their children's school fees through AscentRemit, so they build a record of on-time repayments that improves their creditworthiness.",
      ] },
      { h: "What you'll need", li: [
        "A bachelor's degree (minimum Second Class Lower) or an HND (minimum Upper Credit) in Business Administration, Marketing, Economics, Finance, Banking or a related field.",
        "A completed NYSC, with a discharge or exemption certificate.",
        "3+ years in partnerships, business development or B2B sales, ideally in fintech, lending, edtech or financial services.",
        "A track record of closing and growing partnerships, with numbers to show for it.",
        "Experience selling to schools, SMEs or institutions, and confidence dealing with proprietors, bursars and HR teams.",
        "An understanding of consumer lending and responsible lending, or a willingness to learn fast.",
        "Strong negotiation and communication skills in English, written and spoken.",
        "Willingness to travel across Nigeria to meet schools and partners.",
      ] },
      { h: "It's a bonus if you have", li: [
        "An MBA, or a professional certification such as CIBN, NIMN or CIM.",
        "An existing network among private schools, school associations or large employers.",
        "Experience building or managing a field agent network.",
        "Experience with bank, microfinance or investor partnerships.",
      ] },
      { h: "Why join us", li: [
        "Meaningful work. Every partnership you build keeps more children in class from day one.",
        "Real ownership. As an early hire, you'll help decide which schools, cities and partners we grow into.",
        "Rewarded performance. A competitive salary plus a bonus tied to partners signed and loan volume.",
      ] },
      { h: "How to apply", p: [
        "Email your CV and a short note about a partnership you're proud of to hello@ascentremit.com, with \"Strategic Partnership Manager\" in the subject line. Applications close on 30 November 2026.",
        "Have a question about the role? Call us on +234 806 150 9247 or message us on WhatsApp.",
        "AscentRemit is an equal-opportunity employer. We welcome applicants from all backgrounds.",
      ] },
    ],
    apply_subject: "Strategic Partnership Manager",
    whatsapp: "https://wa.me/2348061509247",
  },
  {
    slug: "academic-lending-manager",
    title: "Academic Lending Manager (ALA)",
    location: "Nationwide",
    type: "Full-time",
    closes: "30 November 2026",
    expires_at: "2026-11-30T23:59:59+01:00",
    reports_to: "Head of Credit",
    sections: [
      { h: "Role summary", p: [
        "Ascentremit is hiring Academic Lending Managers to grow and run the Academic Liquidity Advance (ALA). ALA is a short-term advance for members of Nigeria's academic community: lecturers and other staff of universities, polytechnics and colleges of education.",
        "You will own the ALA loan book end to end. That means signing up institutions and staff unions, bringing in borrowers, keeping credit quality healthy and making sure repayments come in on time. You will work closely with the risk, finance, product and compliance teams.",
        "Reports to: Head of Credit",
      ] },
      { h: "Growth and partnerships", li: [
        "Build and carry out the plan to grow ALA disbursements and the number of active borrowers.",
        "Sign up federal, state and private institutions, setting up payroll-deduction or remittance agreements with their bursaries.",
        "Build working relationships with staff unions and cooperatives (such as ASUU, ASUP, COEASU, SSANU and NASU) and with campus leaders.",
        "Run campus activations, webinars and referral programmes to reach academic staff.",
        "Pick out new segments and institutions to target, using where staff are concentrated across states and geopolitical zones.",
      ] },
      { h: "Credit and portfolio management", li: [
        "Apply ALA credit policy: eligibility, borrowing limits, pricing and tenor, and propose changes based on how the portfolio performs.",
        "Track loan-book health (portfolio at risk, defaults, repayment rates) and act early when it slips.",
        "Work with the risk team on how borrowers are scored, using payroll data, IPPIS and other salary data, and credit bureau checks.",
        "Manage collections and recoveries, including fixing payroll-deduction problems with institutions.",
      ] },
      { h: "Product and operations", li: [
        "Work with the product and engineering teams to improve how borrowers apply, get approved, receive funds and repay.",
        "Make sure most applications are approved and paid out within the turnaround time ALA promises.",
        "Collect borrower feedback and turn it into product improvements.",
      ] },
      { h: "Compliance and reporting", li: [
        "Make sure ALA follows CBN rules, NDPA data protection requirements and FCCPC consumer protection guidance, and that its terms are clearly disclosed.",
        "Report to leadership each week and each month on growth, risk and revenue.",
        "Lead and develop a team of relationship officers and sales associates as the product grows.",
      ] },
      { h: "Requirements — essential", li: [
        "A bachelor's degree in finance, economics, business, banking or a related field.",
        "5+ years in consumer lending, salary-backed loans, microfinance or digital credit, including at least 2 years managing a portfolio or a team.",
        "A track record of growing a loan book while keeping defaults within target.",
        "A solid grasp of credit risk, how to price loans and how to manage collections.",
        "Experience setting up partnerships with institutions or employers, ideally including payroll-deduction arrangements.",
        "Working knowledge of Nigerian lending rules (CBN, FCCPC, NDPA).",
        "Strong numerical and analytical skills: comfortable with Excel or Google Sheets and with dashboards.",
        "Willing to travel to campuses across Nigeria.",
      ] },
      { h: "Requirements — desirable", li: [
        "A professional qualification: ACIB, ACCA, ICAN or CFA.",
        "An existing network in Nigeria's tertiary education sector (bursaries, unions, cooperatives).",
        "Experience at a fintech, or with a digital lending app or embedded finance product.",
        "Basic SQL or experience with BI tools such as Power BI, Looker or Metabase.",
      ] },
      { h: "What makes someone succeed in this role", li: [
        "Thinks commercially, and treats risk as part of growth rather than an obstacle to it.",
        "Builds trust with senior academics, bursars and union leaders.",
        "Takes ownership and gets things done in a fast-moving team.",
        "Communicates clearly in writing and in person.",
      ] },
      { h: "What we offer", li: [
        "A competitive salary, plus a performance bonus tied to growth and portfolio quality.",
        "Health insurance (HMO) and a pension under the Contributory Pension Scheme.",
        "A transport / travel allowance for visits to campuses.",
        "The chance to build a product that makes a real difference to Nigeria's academic community.",
        "Budget for learning and professional certifications.",
      ] },
      { h: "How to apply", p: [
        "Send your CV and a one-page note on how you would grow ALA in your first 90 days to hello@ascentremit.com, with the subject line \"Academic Lending Manager – [Your Name]\". Applications close on 30 November 2026.",
        "AscentRemit is an equal opportunity employer. We welcome applicants of every background, gender and state of origin.",
      ] },
    ],
    apply_subject: "Academic Lending Manager – [Your Name]",
  },
];

export const isLive = (job, now = new Date()) => !job.expires_at || now < new Date(job.expires_at);
export const liveJobs = (now = new Date()) => JOBS.filter((j) => isLive(j, now));
